import { useCallback, useEffect, useRef } from 'react';
import { useBiLogger } from '@wix/cli-telemetry-react';
import { launchTunnel } from './tunnel.js';
import type { Connection } from './tunnel.js';
import { wixCliTunnelBiEvents } from './bi/events.js';
import { useTunnelClient } from './useTunnelClient.js';

export function useTunnel() {
  const connectionRef = useRef<Connection>();
  const tunnelClient = useTunnelClient();
  const biLogger = useBiLogger();

  useEffect(() => {
    return () => {
      connectionRef.current?.close();
    };
  }, []);

  return useCallback(
    async (port: number) => {
      const biEvents = wixCliTunnelBiEvents(biLogger);
      const tunnelCreationBi = biEvents.tunnel();
      try {
        const tunnel = await launchTunnel(port, tunnelClient);
        connectionRef.current = tunnel;
        tunnelCreationBi.finish({ isSuccess: true });
        return { url: tunnel.domain };
      } catch (ex: unknown) {
        tunnelCreationBi.finish({
          isSuccess: false,
          failureReason: ex instanceof Error ? ex.message : 'Unknown error',
        });

        throw ex;
      }
    },
    [tunnelClient, biLogger]
  );
}
